{
  "name": "@authress/login",
  "version": "2.6.480",
  "description": "Universal login sdk for Authress authentication as a service. Provides managed authentication for user identity, authentication, and token verification.",
  "type": "module",
  "module": "./src/index.js",
  "main": "./dist/authress.min.js",
  "types": "./index.d.ts",
  "files": [
    "index.d.ts",
    "src",
    "dist"
  ],
  "exports": {
    ".": {
      "types": "./index.d.ts",
      "import": "./src/index.js",
      "require": "./dist/authress.min.js",
      "default": "./src/index.js"
    }
  },
  "scripts": {
    "build": "node make.js build && vite build",
    "lint": "eslint --ext .js,.ts src tests make.js index.d.ts",
    "test": "check-dts index.d.ts && vitest"
  },
  "dependencies": {
    "cookie": "<1",
    "lodash.take": "^4.1.1"
  },
  "devDependencies": {
    "@authress/eslint-config": "^2.0.14",
    "@babel/core": "^7.28.5",
    "@babel/preset-env": "^7.28.5",
    "@rollup/plugin-babel": "^6.1.0",
    "@typescript-eslint/eslint-plugin": "^8.49.0",
    "@typescript-eslint/parser": "^8.49.0",
    "chai": "^4.2.0",
    "check-dts": "^0.4.4",
    "commander": "^4.0.1",
    "eslint": "^9.39.1",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-node": "^11.1.0",
    "eslint-plugin-promise": "^6.1.1",
    "fs-extra": "^8.1.0",
    "glob": "^7.1.6",
    "sinon": "^7.5.0",
    "sinon-chai": "^3.3.0",
    "terser": "^5.44.1",
    "typescript": "^5.9.3",
    "typescript-eslint": "^8.49.0",
    "vite": "^8.1.3",
    "vitest": "^4.1.9"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/Authress/authress-login.js"
  },
  "keywords": [
    "authentication",
    "authentication as a service",
    "Login",
    "Login Client",
    "universal login",
    "auth",
    "federated login",
    "secure login",
    "application security",
    "IDaaS",
    "authentication",
    "user authentication",
    "user identity",
    "Oauth2",
    "Oauth2.1",
    "Oauth3",
    "platform",
    "platform login",
    "extension",
    "Authress",
    "Authress client",
    "user security",
    "DBSC",
    "Device Bound Session Credentials"
  ],
  "author": "Authress Developers <developers@authress.io> (https://authress.io)",
  "license": "Apache-2.0",
  "bugs": {
    "url": "https://github.com/Authress/authress-login.js/issues"
  },
  "homepage": "https://authress.io",
  "engines": {
    "node": ">=20"
  }
}
